import hoistNonReactStatics from 'hoist-non-react-statics';
import React, { memo, useMemo } from 'react';
import useNextTreeStore from './useNextTreeStore';
const withNextTreeStoreConnect = (mapStateToProps, mapDispatchToProps) => (Component) => {
    const Hoc = props => {
        const { state, dispatch } = useNextTreeStore();
        const stateProps = useMemo(() => (mapStateToProps ? mapStateToProps(state, props) : { state }), [state, props]);
        const dispatchProps = useMemo(() => (mapDispatchToProps ? mapDispatchToProps(dispatch, props) : {}), [dispatch, props]);
        return <Component {...props} {...stateProps} {...dispatchProps}/>;
    };
    return memo(hoistNonReactStatics(Hoc, Component));
};
export default withNextTreeStoreConnect;
